/**
 * hooks/useDebouncedValue.ts
 * Returns a debounced copy of `value` that only updates after `delayMs` of quiet.
 * Used to keep a controlled search input perfectly responsive while the
 * (memoised) filtering runs off the settled term. Client-side only — no network.
 */
import { useEffect, useState } from 'react';

export function useDebouncedValue<T>(value: T, delayMs = 140): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(t);
  }, [value, delayMs]);
  return debounced;
}
